import { render, staticRenderFns } from "./JWL_Facilitator.vue?vue&type=template&id=308b2e09&lang=pug&"
import script from "./JWL_Facilitator.vue?vue&type=script&lang=ts&"
export * from "./JWL_Facilitator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports